<div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                  <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                    <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                  </a>
                </small>
            </div>
            <div class="text-center pagination-small-margin pagination-center">
                <pagination
                    (pageChanged)="search($event)"
                    class="pagination-sm"
                    [boundaryLinks]="true"
                    [totalItems]="maxCount"
                    [maxSize]="searchParams.per_page"
                    [itemsPerPage]="searchParams.per_page"
                    [(ngModel)]="searchParams.page"
                    previousText="&lsaquo;"
                    nextText="&rsaquo;"
                    firstText="&laquo;"
                    lastText="&raquo;"
                ></pagination>
            </div>
            <div class="text-center pt-1">
                <app-pagination-count
                    [count]="maxCount"
                    singularName="Scan"
                    pluralName="Scans"
                ></app-pagination-count>
                <div class="scan-filter-counts small text-left mt-2" *ngIf="openCount !== maxCount">
                    <div class="text-muted text-center mb-1">Open scans by filter</div>
                    <div *ngIf="filterCounts?.states?.length">
                        <div class="text-muted">Status</div>
                        <a
                            class="scan-filter-count-link"
                            *ngFor="let filter of filterCounts.states"
                            routerLink="/scans"
                            [queryParams]="filter.query_params">
                            {{ filter.label }} ({{ filter.count }})
                        </a>
                    </div>
                    <div class="mt-1" *ngIf="filterCounts?.current_state_priorities?.length > 1">
                        <div class="text-muted">Priority</div>
                        <a
                            class="scan-filter-count-link"
                            *ngFor="let filter of filterCounts.current_state_priorities"
                            routerLink="/scans"
                            [queryParams]="filter.query_params">
                            {{ filter.label }} ({{ filter.count }})
                        </a>
                    </div>
                    <div class="mt-1" *ngIf="filterCounts?.current_state_document_types?.length > 1">
                        <div class="text-muted">Type</div>
                        <a
                            class="scan-filter-count-link"
                            *ngFor="let filter of filterCounts.current_state_document_types"
                            routerLink="/scans"
                            [queryParams]="filter.query_params">
                            {{ filter.label }} ({{ filter.count }})
                        </a>
                    </div>
                </div>
                <button
                    class="btn btn-outline-danger btn-sm mt-2"
                    type="button"
                    *ngIf="testCleanupEnabled && openCount > 0"
                    [disabled]="deletingAll"
                    (click)="deleteAllScansConfirm()">
                    Delete All Open Scans and Histories
                    <span *ngIf="deletingAll">
                        &nbsp;
                        <i class="fas fa-spinner fa-fw fa-pulse"></i>
                    </span>
                </button>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                <div class="pull-right float-right">
                    <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
                </div>
                <span>
                    Search&nbsp;&nbsp;
                    <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null) : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
                </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <form>
                        <div class="form-group mt-3">
                            <label for="matter-name">Matter</label>
                            <app-matter-search id="matter-name" [placeholder]="'Search and select'" [small_input]="false" (matter_id)="onMatterSelect($event)"></app-matter-search>
                        </div>
                        <div class="form-group">
                            <label for="priority">Priority</label>
                            <select class="form-control" id="priority" [(ngModel)]="searchParams.priority" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option value="">-- No selection --</option>
                                <option *ngFor="let priority of searchOptions.scan_priorities" [value]="priority.value">{{priority.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="status">Status</label>
                            <select class="form-control" id="status" [(ngModel)]="searchParams.state" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option *ngFor="let state of searchOptions.scan_states" [value]="state.value">{{state.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="type">Type</label>
                            <select class="form-control" id="type" [(ngModel)]="searchParams.doc_type" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
                                <option value="">-- No selection --</option>
                                <option *ngFor="let type of searchOptions.document_types" [value]="type.value">{{type.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <button (click)="searchParams.page = 1; search(null)" class="btn btn-primary btn-sm" style="width: 100%" type="button" [disabled]="searching">
                                Search
                                <span *ngIf="searching">
                                    &nbsp;
                                    <i class="fas fa-spinner fa-fw fa-pulse"></i>
                                </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
            <div class="container-shadow px-3 pb-4">
                <h2 class="pt-4 text-center">Scans</h2>
                <hr class="mt-1 mb-2" />
                <div class="row p-4">
                    <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-4 card-deck" *ngFor="let scan of scans">
                        <div class="card w-100" style="min-height: 400px;">
                            <div class="card-body">
                                <p class="text-right mb-0"><i class="fas fa-times-circle" [ngClass]="{'text-muted': deleting, 'text-danger': !deleting}" title="Delete scan" type="button" (click)="activateIntranet(scan.intranet_id); deleteScanConfirm(scan)"></i></p>
                                <p class="text-center mb-1" *ngIf="scan.intranet_name">
                                    <span class="badge badge-secondary">{{scan.intranet_name}}</span>
                                </p>
                                <h5 class="card-title text-center"><a routerLink="/scans" [queryParams]="{doc_type:(scan.display_document_type_id || scan.document_type_id)}">{{scan.display_document_type_name || scan.document_type_name}}</a></h5>
                                <p class="text-center mb-1 small text-muted" *ngIf="scan.intake_source_context">
                                    {{scan.intake_source_context}}
                                </p>
                                <p class="text-center mb-1 small text-muted" *ngIf="scan.original_filename">
                                    {{scan.original_filename}}
                                </p>
                                <p class="text-center mb-1 small text-success" *ngIf="scan.suggested_document_type && !scan.suggested_document_type_matches_current && !scan.display_suggested_document_type">
                                    Suggested: {{scan.suggested_document_type}}
                                    <span *ngIf="scan.classification_confidence">({{scan.classification_confidence}})</span>
                                </p>
                                <p class="text-center mb-1 small text-success" *ngIf="scan.display_suggested_document_type && scan.classification_confidence">
                                    Suggested ({{scan.classification_confidence}})
                                </p>
                                <p class="text-center mb-1 small text-success" *ngIf="scan.suggested_document_type && scan.suggested_document_type_matches_current">
                                    Suggested match<span *ngIf="scan.classification_confidence"> ({{scan.classification_confidence}})</span>
                                </p>
                                <p class="text-center mb-1 small text-muted" *ngIf="scan.intake_status">
                                    {{scan.intake_status}}
                                </p>
                                <h5 class="text-center"><a href="javascipt: void(0)" type="button" [routerLink]="'/scans/'+ scan.id + '/edit'" (click)="activateIntranet(scan.intranet_id)"><img [src]="scan.png_thumbnail_src" class="card-img-top" alt="..."></a></h5>
                                <p class="text-center mb-0"><a [routerLink]="'/matters/' + scan.matters[0].id" *ngIf="scan.matters.length" (click)="activateIntranet(scan.intranet_id)">{{scan.matters[0].name}}</a></p>
                                <p class="text-center mb-0"><span class="text-primary" *ngIf="!scan.matters.length">No Matter Involved</span></p>
                                <p class="card-text text-center mb-0">
                                    {{scan.scan_info}}
                                </p>
                                <p class="text-center mb-0"><a routerLink="/scans" [queryParams]="{priority:scan.priority}">{{scan.scan_priority_name}}</a></p>
                                <p class="text-center mb-0">{{scan.checked_out_by_name}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>

<ng-template #confirmDeleteModal let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">Confirm deletion</h4>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p [innerHTML]="deleteWarningMessage | safeHtml"></p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="c('Delete')">Confirm delete</button>
      <button type="button" class="btn btn-secondary" (click)="d('Cancel')">Cancel</button>
    </div>
  </ng-template>
